export const n = (value: unknown, fallback = 0) => {
  if (value === null || value === undefined) {
    return fallback;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const formatNumberBR = (value: unknown, digits = 2) =>
  n(value).toLocaleString("pt-BR", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

export const formatMoneyBR = (value: unknown) =>
  n(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });

export const formatDateBR = (value: string | Date | null | undefined) => {
  if (!value) {
    return "-";
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }
  return new Intl.DateTimeFormat("pt-BR").format(date);
};

export const parseDateInput = (value: string) => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const money = formatMoneyBR;

export const parseMoneyBR = (value: string) => {
  if (!value) {
    return 0;
  }
  const normalized = value.replace(/\./g, "").replace(",", ".").trim();
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const pct = (value: unknown, digits = 2) => {
  if (value === null || value === undefined) {
    return "-";
  }
  return `${n(value).toFixed(digits)}%`;
};
